import { cancelOrder } from '@entities/order/model';
import { AppDispatch } from '../../../app/store/store';
import { Order } from '../../../types/interfaces';

export const reverseOrder = (dispatch: AppDispatch, order: Order) => {
  if (order.id) {
    dispatch(cancelOrder({ id: order.id }));
  }
};
